import { render, staticRenderFns } from "./GiveawayView.vue?vue&type=template&id=595373a2&scoped=true"
import script from "./GiveawayView.vue?vue&type=script&lang=js"
export * from "./GiveawayView.vue?vue&type=script&lang=js"
import style0 from "./GiveawayView.vue?vue&type=style&index=0&id=595373a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595373a2",
  null
  
)

export default component.exports